import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const modelsListThunk = createAsyncThunk(
  "model/list",
  proceedThunk(api.modelManager.list)
);

export const ttsVoicesListThunk = createAsyncThunk(
  "model/ttsVoices",
  proceedThunk(api.takebaker.other.ttsVoices)
);
